class userMenu extends HTMLElement {
  constructor() {
    super();

    this.userMenuButton = this.querySelector('.js-user-menu-button');
    this.userMenuDropdown = this.querySelector('.js-user-menu-dropdown');

    if (!this.userMenuButton || !this.userMenuDropdown) {
      return;
    }

    this.userMenuButton.addEventListener('click', () => {
      this.userMenuDropdown.classList.toggle('js-open');
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.userMenuDropdown.classList.remove('js-open');
      }
    });
  }
}

customElements.define('user-menu', userMenu);


class userMenuMobile extends HTMLElement {
  constructor() {
    super();

    this.userMenuMobileButton = this.querySelector('.js-user-menu-mobile-button');
    this.userMenuMobileDrawer = this.querySelector('.js-user-menu-mobile-drawer');

    if (!this.userMenuMobileButton || !this.userMenuMobileDrawer) {
      return;
    }

    this.userMenuMobileButton.addEventListener('click', () => {
      this.userMenuMobileDrawer.classList.toggle('js-open');
      this.userMenuMobileButton.classList.toggle('js-active');
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.userMenuMobileDrawer.classList.remove('js-open');
        this.userMenuMobileButton.classList.remove('js-active');
      }
    });
  }
}

customElements.define('user-menu-mobile', userMenuMobile);


class vendorList extends HTMLElement {
  constructor() {
    super();

    this.collectionUrl = this.dataset.collectionUrl;
    this.collectionId = this.dataset.collectionId;
    this.logoBaseUrl = this.dataset.logoBaseUrl || '';

    this.fetchVendors(this.collectionId);
  }

  async fetchVendors(collectionId) {
    try {
      const apiUrl = `/apps/ecostal/api/vendors/${collectionId}`;

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (!data.vendors) {
        console.error('No vendors found in response');
        return;
      }

      this.renderVendors(data.vendors);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  }

  vendorToSlug(vendor) {
    return vendor
      .trim()
      .toLowerCase()
      .replace(/é|è/g, 'e')
      .replace(/à/g, 'a')
      .replace(/\s+/g, '-');
  }

  renderVendors(vendors) {
    const template = this.querySelector('template');
    const list = this.querySelector('ul');

    if (!template || !list) return;

    vendors.forEach((vendor) => {
      const clone = template.content.cloneNode(true);
      const li = clone.querySelector('li');
      const anchor = clone.querySelector('a');
      const img = clone.querySelector('img');

      const slug = this.vendorToSlug(vendor);
      const logoSrc = `${this.logoBaseUrl}logo-${slug}.webp?v=${Date.now()}`;
      const vendorUrl = `${this.collectionUrl}${encodeURIComponent(vendor)}`;

      if (anchor) {
        anchor.href = vendorUrl;
      }

      if (img) {
        img.src = logoSrc;
        img.dataset.vendor = vendor;
        img.alt = vendor;
        img.onerror = function () {
          this.style.display = 'none';
          this.parentElement.innerHTML = `<span>${vendor}</span>`;
        };
      }

      list.appendChild(clone);
    });
  }
}

customElements.define('vendor-list', vendorList);
